import ReactDOM from "react-dom";
import "./Post.css";
import Markdown from "../../../components/Markdown/Markdown";

function PostDeleteModal({ post, onClose, onConfirm, isDeleting, errorMessage }) {
  return ReactDOM.createPortal(
    <div className="ReportPopupWindow">
      <div className="backgroundBlock" onClick={onClose}></div>
      <div className="ReportForm">
        <h1 className="TitleReport">Delete Post</h1>
        <h3 className="ForNextPost">
          Are you sure you want to delete this post?
        </h3>
        <Markdown>{post.mainText}</Markdown>
        <div style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
          <button
            className="submutReportButton"
            onClick={onClose}
            style={{
              background: "var(--bg-secondary)",
              color: "var(--text-primary)",
              flex: 1,
            }}
          >
            Cancel
          </button>
          <button
            className="submutReportButton"
            onClick={onConfirm}
            disabled={isDeleting}
            style={{ background: "var(--danger-500)", flex: 1 }}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </button>
        </div>
        {errorMessage && (
          <p className={"ErrorMessage show"}>{errorMessage}</p>
        )}
      </div>
    </div>,
    document.body,
  );
}

export default PostDeleteModal;
